var $$ = $$ || {};

$$.LearnHowToOrder = class LearnHowToOrder {
	constructor (root, options) {
		this.root = root;

		this._bindEvents();
	}

	_bindEvents () {
		this.root.on('click', function (event) {
			event.preventDefault();

			$('.js-upper-header .js-feedback').trigger('click');
			$('.p-user-form.call-me.feedback-form').find('.tab').last().trigger('click');
		})
	}
};
